import { createContext, useContext, useState } from "react";

export const CONTACTS = {
  phone: "+390656196337",
  phoneLabel: "+39 06 5619 6337",
  email: "info@santireneroma.com",
  instagram: "santireneroma",
  instagramUrl: "https://instagram.com/santireneroma",
  superbUrl: "https://santirene.superbexperience.com",
  address: "Via Flaminia 976, 00189 Roma RM",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Via+Flaminia+976+Roma",
};

export const translations = {
  it: {
    payoff: "Storia di una Famiglia",
    locationTag: "Via Flaminia 976 — Roma Nord",
    photoComingSoon: "Fotografia in arrivo",
    nav: {
      story: "La Storia",
      philosophy: "Cucina",
      menu: "Menu",
      gallery: "Galleria",
      spaces: "Gli Spazi",
      contacts: "Contatti",
      reserve: "Prenota",
    },
    hero: {
      subtitle:
        "Una tavola costruita intorno alla materia prima, al territorio, alla stagionalità e alle nostre radici.",
      subtitle2:
        "A table shaped by ingredients, place, seasonality and our roots.",
      ctaBook: "Prenota un Tavolo",
      ctaMenu: "Scopri il Menu",
      scroll: "Scorri",
      hoursLine1: "Mar — Sab · 12:30 – 15:30 · 19:30 – 23:00",
      hoursLine2: "Dom · 12:30 – 16:00 · 19:30 – 23:00 — Lunedì chiuso",
    },
    marquee: [
      "Pescato del Giorno",
      "Brace di Leccio e Ulivo",
      "Memoria di Famiglia",
      "Stagionalità",
      "Cantina del Flaminio",
      "Roma Nord",
    ],
    story: {
      eyebrow: "Capitolo I — Le Radici",
      title: "Nessun segreto. Solo il tempo necessario per fare le cose bene.",
      desc1:
        "Sant'Irene nasce attorno al calore di una tavola domenicale che negli anni non ha mai smesso di crescere. È l'omaggio a chi ci ha insegnato che il cibo è prima di tutto accoglienza: rispetto per chi coltiva, pesca e alleva, e la gioia semplice dello stare insieme.",
      desc2:
        "In Via Flaminia 976, tra il verde di Roma Nord e l'aria che scende dal Tevere, apriamo le porte di una casa pensata per chi cerca l'eccellenza senza rigidità. Mare e terra, memoria e cucina contemporanea.",
      quote:
        "«Ogni piatto che serviamo è una pagina di famiglia: scritta a mano, riletta con cura, portata in tavola con orgoglio.»",
      signature: "La Famiglia Sant'Irene",
    },
    philosophy: {
      eyebrow: "Capitolo II — Il Dialogo",
      title: "Due anime, una sola convinzione",
      intro:
        "La nostra cucina vive di un dialogo continuo: la purezza del mare e la forza gentile della terra, del pascolo e del fuoco vivo.",
      seaTitle: "La Memoria del Mare",
      seaDesc:
        "Pescato del giorno, scelto ogni mattina con cura. Crudi battuti al coltello, fumetti limpidi e cotture essenziali che lasciano parlare la materia.",
      landTitle: "La Brace",
      landDesc:
        "Selezioni etiche di carne, frollate con pazienza. Fuoco vivo di leccio e ulivo per restituire profondità ancestrale a ogni taglio.",
      seaNote: "Pescato del giorno · Crudi · Cotture essenziali",
      landNote: "Frollature · Legna di leccio · Tagli al coltello",
    },
    menu: {
      eyebrow: "Alla Carta",
      title: "Il Menu",
      lunch: "Pranzo",
      dinner: "Cena",
      intro:
        "Una carta che segue il ritmo delle stagioni e del mercato. I piatti cambiano con la materia prima: quello che leggete oggi è la nostra stagione.",
      note: "La carta segue la stagionalità e il pescato del giorno: alcuni piatti potrebbero non essere sempre disponibili.",
      allergenNote:
        "Per allergie e intolleranze il nostro personale è a completa disposizione.",
      categories: {
        fritti: "Fritti",
        antipasti: "Antipasti",
        primi: "Primi",
        secondi: "Secondi",
        dolci: "Dolci",
        insalate: "Insalate e Piatti Unici",
        fattoria: "Dalla Fattoria",
        primiTradizione: "Tradizione Romana",
        primiCasa: "Primi della Casa",
      },
    },
    gallery: {
      eyebrow: "In Tavola",
      title: "La Galleria",
    },
    spaces: {
      eyebrow: "Capitolo III — La Casa",
      title: "Gli Spazi",
      intro:
        "Tre ambienti, un'unica atmosfera: luce calda, materiali naturali, il rumore giusto di una casa che vive.",
      items: [
        {
          name: "La Nostra Sala",
          desc: "Il cuore del ristorante: la cucina a vista attorno al fuoco di leccio, tavoli in rovere e luce di candela.",
        },
        {
          name: "Il Corridoio Ambrato",
          desc: "Il passaggio che accompagna gli ospiti verso la sala: pareti grafite e una panca ambra retroilluminata.",
        },
        {
          name: "La Sala della Griglia",
          desc: "La seconda sala, raccolta e luminosa, con la sua nicchia dei vini: ideale per pranzi di lavoro e cene tra amici.",
        },
      ],
    },
    reservation: {
      eyebrow: "Prenotazioni",
      title: "Il vostro tavolo vi aspetta",
      subtitle:
        "Le prenotazioni sono gestite tramite il portale Superb Experience, per garantirvi la massima cura fin dal primo contatto. Preferite la voce? Chiamateci o scriveteci.",
      superbBtn: "Prenota il tuo Tavolo",
      phoneBtn: "Chiama il Ristorante",
      emailBtn: "Scrivici una Email",
      policyNote:
        "Per tavoli oltre 10 ospiti o eventi privati, contattateci direttamente via email o telefono.",
      hoursTitle: "Orari di Servizio",
      hours: [
        ["Lunedì", "Chiuso"],
        ["Martedì — Sabato", "12:30 – 15:30 · 19:30 – 23:00"],
        ["Domenica", "12:30 – 16:00 · 19:30 – 23:00"],
      ],
    },
    location: {
      eyebrow: "Dove Trovarci",
      title: "Roma Nord, Via Flaminia 976",
      desc: "A pochi minuti da Ponte Milvio e dal Parco di Veio, con ampia disponibilità di parcheggio lungo la via.",
      directions: "Indicazioni Stradali",
      parking: "Parcheggio facile lungo Via Flaminia",
    },
    instagram: {
      eyebrow: "Seguiteci",
      title: "@santireneroma",
    },
    footer: {
      tagline:
        "Un ristorante di famiglia, a Roma. Mare, terra e memoria contemporanea.",
      newsletterTitle: "Cene private e novità",
      newsletterPlaceholder: "La vostra email",
      newsletterBtn: "Iscriviti",
      newsletterSuccess: "Grazie — vi scriveremo presto.",
      rights: "Tutti i diritti riservati",
      vat: "P.IVA 18642571006",
      privacy: "Privacy",
      cookies: "Cookie",
    },
    sticky: {
      call: "Chiama",
      book: "Prenota",
    },
    langName: "IT",
  },
  en: {
    payoff: "A Family Story",
    locationTag: "Via Flaminia 976 — North Rome",
    photoComingSoon: "Photography coming soon",
    nav: {
      story: "Our Story",
      philosophy: "Cuisine",
      menu: "Menu",
      gallery: "Gallery",
      spaces: "Spaces",
      contacts: "Contact",
      reserve: "Reserve",
    },
    hero: {
      subtitle:
        "A table shaped by ingredients, place, seasonality and our roots.",
      subtitle2:
        "Una tavola costruita intorno alla materia prima, al territorio, alla stagionalità e alle nostre radici.",
      ctaBook: "Book a Table",
      ctaMenu: "Explore the Menu",
      scroll: "Scroll",
      hoursLine1: "Tue — Sat · 12:30 – 15:30 · 19:30 – 23:00",
      hoursLine2: "Sun · 12:30 – 16:00 · 19:30 – 23:00 — Closed Mondays",
    },
    marquee: [
      "Catch of the Day",
      "Holm Oak & Olive Embers",
      "Family Memory",
      "Seasonality",
      "Flaminia Cellar",
      "North Rome",
    ],
    story: {
      eyebrow: "Chapter I — Roots",
      title: "No secrets. Just the time it takes to do things properly.",
      desc1:
        "Sant'Irene was born around the warmth of a Sunday table that never stopped growing over the years. It is a tribute to those who taught us that food is, first of all, hospitality: respect for those who farm, fish and raise, and the simple joy of being together.",
      desc2:
        "At Via Flaminia 976, between the green of North Rome and the air drifting down from the Tiber, we open the doors of a home made for those who seek excellence without stiffness. Sea and land, memory and contemporary cuisine.",
      quote:
        "“Every dish we serve is a family page: handwritten, carefully re-read, proudly brought to the table.”",
      signature: "The Sant'Irene Family",
    },
    philosophy: {
      eyebrow: "Chapter II — The Dialogue",
      title: "Two souls, one conviction",
      intro:
        "Our cuisine lives in a constant dialogue: the purity of the sea and the gentle strength of land, pasture and living fire.",
      seaTitle: "Memory of the Sea",
      seaDesc:
        "Catch of the day, chosen with care every morning. Knife-cut crudi, clear broths and essential cooking that lets the ingredient speak.",
      landTitle: "Embers",
      landDesc:
        "Ethical meat selections, patiently dry-aged. Living fire of holm oak and olive wood restoring ancestral depth to every cut.",
      seaNote: "Catch of the day · Crudi · Essential cooking",
      landNote: "Dry-aging · Holm oak wood · Knife-cut selections",
    },
    menu: {
      eyebrow: "À la Carte",
      title: "The Menu",
      lunch: "Lunch",
      dinner: "Dinner",
      intro:
        "A menu that follows the rhythm of the seasons and the market. Dishes change with the ingredients: what you read today is our season.",
      note: "Our menu follows seasonality and the day's catch: some dishes may not always be available.",
      allergenNote:
        "For allergies and intolerances, our staff is entirely at your disposal.",
      categories: {
        fritti: "To Begin",
        antipasti: "Starters",
        primi: "First Courses",
        secondi: "Mains",
        dolci: "Desserts",
        insalate: "Salads & One-Plate Dishes",
        fattoria: "From the Farm",
        primiTradizione: "Roman Classics",
        primiCasa: "House First Courses",
      },
    },
    gallery: {
      eyebrow: "At the Table",
      title: "The Gallery",
    },
    spaces: {
      eyebrow: "Chapter III — The House",
      title: "The Spaces",
      intro:
        "Three rooms, one atmosphere: warm light, natural materials, the right murmur of a living home.",
      items: [
        {
          name: "Our Dining Room",
          desc: "The heart of the restaurant: an open kitchen around the holm oak fire, oak tables and candlelight.",
        },
        {
          name: "The Amber Corridor",
          desc: "The passage leading guests to the dining room: graphite walls and a backlit amber bench.",
        },
        {
          name: "The Grill Room",
          desc: "The second dining room, intimate and bright, with its wine niche: ideal for business lunches and dinners with friends.",
        },
      ],
    },
    reservation: {
      eyebrow: "Reservations",
      title: "Your table awaits",
      subtitle:
        "Reservations are managed through the Superb Experience portal, to guarantee the utmost care from the very first contact. Prefer a voice? Call us or write to us.",
      superbBtn: "Book Your Table",
      phoneBtn: "Call the Restaurant",
      emailBtn: "Send an Email",
      policyNote:
        "For tables over 10 guests or private events, please contact us directly by email or phone.",
      hoursTitle: "Opening Hours",
      hours: [
        ["Monday", "Closed"],
        ["Tuesday — Saturday", "12:30 – 15:30 · 19:30 – 23:00"],
        ["Sunday", "12:30 – 16:00 · 19:30 – 23:00"],
      ],
    },
    location: {
      eyebrow: "Find Us",
      title: "North Rome, Via Flaminia 976",
      desc: "A few minutes from Ponte Milvio and the Veio Park, with ample parking along the street.",
      directions: "Get Directions",
      parking: "Easy parking along Via Flaminia",
    },
    instagram: {
      eyebrow: "Follow Us",
      title: "@santireneroma",
    },
    footer: {
      tagline:
        "A family restaurant in Rome. Sea, land and contemporary memory.",
      newsletterTitle: "Private dinners & news",
      newsletterPlaceholder: "Your email",
      newsletterBtn: "Subscribe",
      newsletterSuccess: "Thank you — we will write to you soon.",
      rights: "All rights reserved",
      vat: "VAT 18642571006",
      privacy: "Privacy",
      cookies: "Cookies",
    },
    sticky: {
      call: "Call",
      book: "Book",
    },
    langName: "EN",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
